import { IProduct } from '@frontend/product/types';

import { useScreen } from '../screens/useScreen';

export interface KioskBasketItem {
    product: IProduct;
    quantity: number;
}

/** Keeps an order basket in the active kiosk wizard until it is checked out. */
export const useWizardBasketItems = () => {
    const { wizardData, updateWizardData } = useScreen();
    const basketItems = (wizardData.basketItems as KioskBasketItem[] | undefined) ?? [];

    const addBasketItem = (product: IProduct, quantity: number) => {
        const existingItem = basketItems.find((item) => item.product.id === product.id);
        const nextItems = existingItem
            ? basketItems.map((item) => (item.product.id === product.id ? { ...item, quantity: item.quantity + quantity } : item))
            : [...basketItems, { product, quantity }];
        updateWizardData({ basketItems: nextItems });
    };

    const updateBasketItem = (productId: string, quantity: number) => {
        updateWizardData({
            basketItems:
                quantity > 0
                    ? basketItems.map((item) => (item.product.id === productId ? { ...item, quantity } : item))
                    : basketItems.filter((item) => item.product.id !== productId)
        });
    };

    return { basketItems, addBasketItem, updateBasketItem };
};
